import styled from "styled-components";

export const Mobile = styled.div`
  display: grid;
  gap: 32px;

  @media (min-width: 1000px) {
    display: none;
  }
`

export const Desk = styled.div`
  display: none;

  @media (min-width: 1000px) {
    display: block;
  }
`

export const Card = styled.article`
  border-radius: 16px;
  padding: 1px;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(160px 50px at 50% -22px,
      #2a73ff 0%,
      rgba(42,115,255,0.55) 50%,
      rgba(42,115,255,0) 70%) border-box,
    linear-gradient(#363636, #363636) border-box;
    margin: 0 24px;

  .colors{
    height: 156px;
    width: 156px;
    border-radius: 100%;
    filter: blur(var(--blur, 100px));
    opacity: var(--alpha, 1);
    mix-blend-mode: screen;
    will-change: transform, filter;
    position: absolute;
  }
  .blue{ background-color: #2A73FF80; top: -70px; right: -70px; }
  .pink{ background-color: #D7208280; bottom: -70px; left: -70px; }

  .module{
    background-color: #000;
    padding: 16px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    transition: transform .35s ease, filter .35s ease, box-shadow .35s ease;
    will-change: transform, filter, box-shadow;
    height: 100%;
  }

  &[data-active="true"] .module{
    transform: translateY(-2px) scale(1.01);
    filter: brightness(1.05) saturate(1.05);
    box-shadow: 0 12px 30px rgba(0,87,255,0.18);
  }

  &[data-active="true"]::after{
    content:"";
    position:absolute; 
    inset:0; 
    border-radius:16px; 
    pointer-events:none;
   
    opacity: .85;
    padding: 1px;
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor; mask-composite: exclude;
  }

  @media (prefers-reduced-motion: reduce){
    .module{ transition: none; }
  }

  img{
    width: 52px;
  }
`;

export const CardTitle = styled.h4`
  font-weight: 600;
  font-style: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  text-transform: capitalize;
  background: linear-gradient(90deg, var(--color-2a73ff) 0%, var(--color-8A69BE) 15%, var(--color-d72082) 25%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

export const CardBody = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;